import React from 'react';

const Title = ({ record }) => {
  return <span>User { `${ record.login } (${ record.name })` }</span>;
};

export default Title;
